import React from "react";
import Preloader from "../helper/Preloader";
import Breadcrumb from "../components/Breadcrumb";
 import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import CheckoutAmazon from "../componentsAmazon/CheckoutAmazon";
import HeaderOneCustomer from "../componentsAmazon/HeaderOneCustomer";
import FooterOne from "../components/FooterOne";


const CheckoutPageAmazon = () => {



  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOneCustomer />

      {/* Breadcrumb */}
      <Breadcrumb title={"Checkout"} />

      {/* CheckoutAmazon */}
      <CheckoutAmazon />
 
      {/*  */}
      <FooterOne/>

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default CheckoutPageAmazon;
